package com.patronat.top.client.location

data class ClientGeoLocation(
    val latitude: Double,
    val longitude: Double
)

data class ClientLocationSuggestion(
    val id: String,
    val title: String,
    val placeName: String,
    val latitude: Double,
    val longitude: Double,
    val placeType: List<String> = emptyList()
) {
    fun toGeoLocation(): ClientGeoLocation {
        return ClientGeoLocation(
            latitude = latitude,
            longitude = longitude
        )
    }
}

interface ClientLocationProvider {
    suspend fun getCurrentLocation(): ClientGeoLocation?
}
